import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { NotificationService } from 'src/app/Service/notification.service';

@Component({
  selector: 'app-ccn-advance-search',
  templateUrl: './ccn-advance-search.component.html',
  styleUrls: ['./ccn-advance-search.component.css']
})
export class CcnAdvanceSearchComponent implements OnInit {
  @Output() advancedSearchStatus: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Input() searchList: any[] = [];
  public searchForm: FormGroup = new FormGroup({
    ctrlSearchText: new FormControl(),
    ctrlType: new FormControl(),
    ctrlDisc: new FormControl(),
    ctrlRevision: new FormControl()
  });
  public searchTypeList: any[] = [];
  public searchDisciplineList: any[] = [];
  public searchRevisionList: any[] = [];

  constructor(
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.getSearchTypes();
    this.getRevisionList();
    this.getDisciplineList();
  }

  closeAdvanceSearch(event:any) {
    this.advancedSearchStatus.emit(this.searchList);
  }

  public clearSearch() {
    this.searchForm.reset();
  }

  getSearchTypes() {
    this.searchTypeList = [];
    this.searchTypeList.push(
      { value: 0, description: 'CCN Number' },
      { value: 1, description: 'CCN Title' }
    );
  }

  public getRevisionList() {
    let result = this.searchList.map(x => x.ccnRevNo);
    let filteredResult = result.filter((n, i) => result.indexOf(n) === i);
    filteredResult.forEach(x => {
      this.searchRevisionList.push({ value: x, description: x });
    })
  }

  public getDisciplineList() {
    let result = this.searchList.map(x => x.discipline);
    let filteredResult = result.filter((n, i) => result.indexOf(n) === i);
    filteredResult.forEach(x => {
      this.searchDisciplineList.push({ value: x, description: x });
    })
  }

  public searchData() {
    let searchText = this.searchForm.controls['ctrlSearchText'].value;
    let type = this.searchForm.controls['ctrlType'].value;
    let revision = this.searchForm.controls['ctrlRevision'].value;
    let disc = this.searchForm.controls['ctrlDisc'].value;
    if (searchText != null && searchText != '') {
      if (type != null) {
        if (type == 'CCN Number') {
          this.searchList = this.searchList.filter(x => x.ccnNo.toLowerCase().includes(searchText.toLowerCase()));
        }
        else if (type == 'CCN Title') {
          this.searchList = this.searchList.filter(x => x.ccnTitle.toLowerCase().includes(searchText.toLowerCase()));
        }

      }
      else {
        this.notificationService.showToast("Please Select Type", "Warning");
        return;
      }
    }
    if (disc != null) {
      this.searchList = this.searchList.filter(x => x.discipline == disc);
    }
    if (revision != null) {
      this.searchList = this.searchList.filter(x => x.ccnRevNo == revision);
    }
    this.advancedSearchStatus.emit(this.searchList);
  }

}
